import { render, staticRenderFns } from "./SignUpIndie.vue?vue&type=template&id=aed5fda4&"
import script from "./SignUpIndie.vue?vue&type=script&lang=js&"
export * from "./SignUpIndie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports